import React from 'react';
import classes from './socialLinks.module.css';
import { SOCIAL_LINKS } from './socialLinksData';
import SocialIcon from './SocialIcon';

const SocialLinks = ({
    variant = 'header',
    className = '',
    linkClassName = '',
    iconClassName = '',
}) => {
    const isBlog = variant === 'blog';
    const rootClass = [classes.root, isBlog ? classes.blog : classes.header, className]
        .filter(Boolean)
        .join(' ');
    const iconClass = [classes.icon, iconClassName].filter(Boolean).join(' ');
    const imgClass = isBlog ? classes.iconImg : iconClass;

    return (
        <div className={rootClass}>
            {SOCIAL_LINKS.map(({ id, href, label }) => (
                <a
                    key={id}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={[classes.link, linkClassName].filter(Boolean).join(' ')}
                    aria-label={label}
                >
                    <SocialIcon id={id} className={iconClass} imgClassName={imgClass} />
                </a>
            ))}
        </div>
    );
};

export default SocialLinks;
